// style関係のロジックをまとめる
import { simpleCopy } from '../deepCopy';

/**
 * styledComponents用
 * 仕様上、スタイルの優先度が1番低いため、カスタムスタイルを実装する際に!importantをつける必要がある
 * この関数で、styleに対して一括で!importantを付与する
 * @param style ex) {color: white;}
 * @param useImportant !importantを付与するかどうか
 * @returns ex) {color: white !important;}
 */
const appendImportantStyle = (style: Record<string, string>, useImportant = true): Record<string, string> => {
  const output = simpleCopy(style);
  for (const property of Object.keys(style)) {
    output[property] = style[property] + ' !important;';
  }
  return output;
};

export { appendImportantStyle };
